import fetcher from '@api/fetchers/simpleFetcher';
import { getHost } from '@utils/api-helper/host';

import {
  SpecialClassesResponse,
  SpecialClassFiltersResponse,
  SubCategoriesResponse,
  LiveNowResponse,
  SheldonLibraryResponse,
  PlaylistDetailsResponse
} from './types';

const host = getHost();

export const fetchSpecialClasses = (
  goalUID: string,
  accessToken?: string
): Promise<SpecialClassesResponse> =>
  fetcher(
    `${host}v3/uplus/${goalUID}/special_classes/?limit=10&offset=0&class_type=all`,
    {
      authorization: accessToken
    }
  );

export const fetchPrimeSubCategories = (
  goalUID: string,
  accessToken?: string
): Promise<SubCategoriesResponse> =>
  fetcher(
    `${host}v2/library/prime-vertical/sub_categories/?topology_uid=${goalUID}`,
    {
      authorization: accessToken
    }
  );

export const fetchLiveNow = (
  goalUID: string,
  accessToken?: string
): Promise<LiveNowResponse> =>
  fetcher(`${host}v1/uplus/special_class/live_now/?goal_uid=${goalUID}`, {
    authorization: accessToken
  });

export const fetchSheldonLibrary = (
  subCategoryUID: string,
  accessToken?: string
): Promise<SheldonLibraryResponse> =>
  fetcher(`${host}sheldon/v1/library/home?sub_category_uid=${subCategoryUID}`, {
    authorization: accessToken
  });

export const fetchPrimeVideoDetails = (
  videoUid: string,
  accessToken?: string
): Promise<any> =>
  fetcher(`${host}v2/library/video/${videoUid}/detail/`, {
    authorization: accessToken,
    useCamelCase: false
  });

export const fetchPrimePlaylistDrawer = (
  playlistUid: string,
  accessToken?: string
): Promise<any> =>
  fetcher(`${host}v2/library/playlist/${playlistUid}/drawer/`, {
    authorization: accessToken,
    useCamelCase: false
  });

export const fetchPrimePlaylistItems = (
  playlistUid: string,
  accessToken?: string
): Promise<PlaylistDetailsResponse> =>
  fetcher(`${host}v2/library/playlist/${playlistUid}/items/`, {
    ...(accessToken ? { authorization: accessToken } : {})
  });

export const fetchSpecialClassFilters = (
  goalUID: string
): Promise<SpecialClassFiltersResponse> =>
  fetcher(`${host}v1/uplus/special-class-filters/?goal_uid=${goalUID}`);

export const fetchFreeClasses = (
  goalUID: string,
  options: {
    classType?: string;
    educator?: string;
    accessToken?: string;
  } = {}
): Promise<SpecialClassesResponse> => {
  const { classType = 'all', educator, accessToken } = options;
  const params = new URLSearchParams({
    limit: '10',
    offset: '0',
    class_type: classType
  });
  if (educator) params.append('educator', educator);
  return fetcher(
    `${host}v3/uplus/${goalUID}/special_classes/?${params.toString()}`,
    {
      authorization: accessToken
    }
  );
};
